export const isEmpty = (arr: any[]) => {
  return arr.length === 0;
};
